import React from 'react'
import ForgotPassword from '../components/ForgotPassword/ForgotPassword'

const ForgotPasswordPage = () => {
    return <ForgotPassword />
}

export default ForgotPasswordPage
